module.exports = __webpack_public_path__ + "a6b63525bb5e3685b5affd766ea5f094.png";